export default "__VITE_ASSET__C7vVHUN6__$_?nuxt_component=async&nuxt_component_name=SvgoList&nuxt_component_export=default__"